import { useQuery } from '@tanstack/react-query';
import { DesktopShell } from '../components/DesktopShell';
import { TopBar } from '../components/TopBar';
import { Card } from '../components/Card';
import { Pill } from '../components/Pill';
import { AdminTabs } from '../components/AdminTabs';
import { adminApi } from '../api/admin';
import { formatDate } from '../lib/date';

export function AdminRoomsPage() {
  const list = useQuery({ queryKey: ['admin-rooms'], queryFn: adminApi.listRooms });
  const rooms = list.data ?? [];

  return (
    <DesktopShell>
      <TopBar title="Panel admina" subtitle="Lista pokoi" />
      <AdminTabs />
      <div className="responsive-pad" style={{ flex: 1, padding: '0 36px 40px' }}>
        <h3 className="serif" style={{ margin: '0 0 14px', fontSize: 18, fontWeight: 700 }}>
          Wszystkie pokoje <span style={{ color: '#5b6578', fontWeight: 500 }}>· {rooms.length}</span>
        </h3>

        {list.isLoading && <Card padding={20}>Ładowanie…</Card>}

        {rooms.length > 0 && (
          <Card padding={0}>
            {rooms.map((r, i) => (
              <div
                key={r.id}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: 14,
                  padding: '14px 22px',
                  borderBottom: i < rooms.length - 1 ? '1px solid rgba(15,30,61,.06)' : 'none',
                }}
              >
                <div
                  style={{
                    width: 40,
                    height: 40,
                    borderRadius: 10,
                    background: 'rgba(15,30,61,.06)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: 20,
                    flexShrink: 0,
                  }}
                >
                  {r.emoji ?? '🏟️'}
                </div>
                <div style={{ flex: 1, minWidth: 0 }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap' }}>
                    <span style={{ fontWeight: 700, fontSize: 14 }}>{r.name}</span>
                    <Pill color={r.type === 'PUBLIC' ? 'accent' : 'gray'}>
                      {r.type === 'PUBLIC' ? 'PUBLICZNY' : 'PRYWATNY'}
                    </Pill>
                    <Pill color="gray">{r.memberCount} {memberLabel(r.memberCount)}</Pill>
                  </div>
                  <div
                    style={{
                      fontSize: 12,
                      color: '#5b6578',
                      marginTop: 4,
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      whiteSpace: 'nowrap',
                    }}
                  >
                    Założony przez <b>{r.ownerNick ?? '—'}</b> · {formatDate(r.createdAt)}
                  </div>
                </div>
              </div>
            ))}
          </Card>
        )}

        {!list.isLoading && rooms.length === 0 && (
          <Card padding={24} style={{ textAlign: 'center', color: '#5b6578' }}>
            Brak pokoi.
          </Card>
        )}
      </div>
    </DesktopShell>
  );
}

function memberLabel(n: number): string {
  if (n === 1) return 'członek';
  const last = n % 10;
  const lastTwo = n % 100;
  if (last >= 2 && last <= 4 && (lastTwo < 12 || lastTwo > 14)) return 'członków';
  return 'członków';
}
